/* Contact Me slice — visible captcha gate, then email submit. */
(function () {
  var TILES = 9;
  var BEES = 3;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var BEE_SVG =
    '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false">' +
    '<ellipse cx="12" cy="13" rx="5.2" ry="4.2" fill="currentColor"/>' +
    '<path d="M8.2 13h7.6M9.2 10.6h5.6M9.2 15.4h5.6" stroke="#16233F" stroke-width="1.15"/>' +
    '<circle cx="10.2" cy="8.2" r="2.1" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
    '<circle cx="13.8" cy="8.2" r="2.1" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
    '</svg>';
  var EMPTY_SVG =
    '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
    '<rect x="5" y="5" width="14" height="14" rx="3" fill="none" stroke="currentColor" stroke-width="1.4" stroke-dasharray="2 2"/>' +
    '</svg>';

  function shuffle(list) {
    var i;
    var j;
    var t;
    for (i = list.length - 1; i > 0; i -= 1) {
      j = Math.floor(Math.random() * (i + 1));
      t = list[i];
      list[i] = list[j];
      list[j] = t;
    }
    return list;
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function initRoot(root) {
    if (root.dataset.contactReady === 'true') return;
    root.dataset.contactReady = 'true';

    var success = root.querySelector('[data-contact-success]');
    if (success) return;

    var captcha = root.querySelector('[data-contact-captcha]');
    var robot = root.querySelector('[data-captcha-robot]');
    var challenge = root.querySelector('[data-captcha-challenge]');
    var grid = root.querySelector('[data-captcha-grid]');
    var status = root.querySelector('[data-captcha-status]');
    var verifyBtn = root.querySelector('[data-captcha-verify]');
    var refreshBtn = root.querySelector('[data-captcha-refresh]');
    var formWrap = root.querySelector('[data-contact-form-wrap]');
    var form = root.querySelector('form.contact-me__form');
    var formStatus = root.querySelector('[data-contact-form-status]');
    var submitBtn = root.querySelector('[data-contact-submit]');
    var honey = root.querySelector('[data-contact-honey]');
    var toLine = root.querySelector('[data-contact-to]');
    var mailto = root.querySelector('[data-contact-mailto]');

    if (!captcha || !grid || !formWrap || !form) return;

    var beeSet = {};
    var verified = false;
    var sending = false;

    function destEmail() {
      var encoded = formWrap.getAttribute('data-contact-dest') || '';
      if (!encoded) return '';
      try {
        return window.atob(encoded).trim();
      } catch (err) {
        return '';
      }
    }

    function hideForm() {
      formWrap.hidden = true;
      formWrap.setAttribute('inert', '');
      if (toLine) toLine.hidden = true;
      if (mailto) {
        mailto.removeAttribute('href');
        mailto.textContent = '';
      }
    }

    function revealForm() {
      verified = true;
      captcha.dataset.verified = 'true';
      if (robot) {
        robot.setAttribute('aria-checked', 'true');
        robot.classList.add('is-checked');
      }
      if (challenge) challenge.hidden = true;
      formWrap.hidden = false;
      formWrap.removeAttribute('inert');
      var dest = destEmail();
      if (toLine && mailto && dest) {
        mailto.href = 'mailto:' + dest;
        mailto.textContent = dest;
        toLine.hidden = false;
      }
      setText(status, 'Verified. Contact form is now visible.');
      var first = form.querySelector('input:not([type="hidden"]):not(.contact-me__honey)');
      if (first) first.focus();
    }

    function buildGrid() {
      var indexes = shuffle([0, 1, 2, 3, 4, 5, 6, 7, 8]);
      beeSet = {};
      indexes.slice(0, BEES).forEach(function (i) {
        beeSet[i] = true;
      });
      grid.replaceChildren();
      var i;
      for (i = 0; i < TILES; i += 1) {
        var isBee = Boolean(beeSet[i]);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'contact-me__tile';
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Image ' + (i + 1));
        btn.dataset.index = String(i);
        btn.innerHTML = isBee ? BEE_SVG : EMPTY_SVG;
        if (isBee) btn.classList.add('contact-me__tile--bee');
        btn.addEventListener('click', function () {
          var pressed = this.getAttribute('aria-pressed') === 'true';
          this.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          this.classList.toggle('is-selected', !pressed);
        });
        grid.appendChild(btn);
      }
      setText(status, 'Select every tile with a bee, then verify.');
    }

    function checkTiles() {
      var tiles = grid.querySelectorAll('.contact-me__tile');
      var i;
      var tile;
      var selected;
      var shouldBee;
      for (i = 0; i < tiles.length; i += 1) {
        tile = tiles[i];
        selected = tile.getAttribute('aria-pressed') === 'true';
        shouldBee = Boolean(beeSet[i]);
        if (selected !== shouldBee) return false;
      }
      return true;
    }

    hideForm();
    buildGrid();
    if (challenge) challenge.hidden = true;

    if (robot) {
      robot.addEventListener('click', function () {
        if (verified) return;
        if (challenge) {
          challenge.hidden = false;
          setText(status, 'Select every tile with a bee, then verify.');
        }
      });
    } else if (challenge) {
      challenge.hidden = false;
    }

    if (refreshBtn) {
      refreshBtn.addEventListener('click', function () {
        if (verified) return;
        buildGrid();
      });
    }

    if (verifyBtn) {
      verifyBtn.addEventListener('click', function () {
        if (verified) return;
        if (checkTiles()) {
          revealForm();
          return;
        }
        setText(status, 'Try again. Select every tile with a bee — and only those tiles.');
        buildGrid();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return;
      if (!verified) {
        setText(formStatus, 'Complete the captcha to view and send the form.');
        return;
      }
      if (honey && honey.value) {
        setText(formStatus, 'Thanks — your message was sent.');
        formWrap.hidden = true;
        captcha.hidden = true;
        return;
      }

      var nameInput = form.querySelector('[name="contact[name]"]');
      var emailInput = form.querySelector('[name="contact[email]"]');
      var bodyInput = form.querySelector('[name="contact[body]"]');
      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var message = bodyInput ? bodyInput.value.trim() : '';

      if (name.length < 2) {
        setText(formStatus, 'Please enter your name.');
        if (nameInput) nameInput.focus();
        return;
      }
      if (!EMAIL_RE.test(email)) {
        setText(formStatus, 'Please enter a valid email address.');
        if (emailInput) emailInput.focus();
        return;
      }
      if (message.length < 10) {
        setText(formStatus, 'Please enter a message (at least 10 characters).');
        if (bodyInput) bodyInput.focus();
        return;
      }

      var lastSent = 0;
      try {
        lastSent = Number(sessionStorage.getItem('biblebee-contact-sent') || '0');
      } catch (err) {
        lastSent = 0;
      }
      if (lastSent && Date.now() - lastSent < 20000) {
        setText(formStatus, 'Please wait a moment before sending another message.');
        return;
      }

      var dest = destEmail();
      var shopName = root.getAttribute('data-shop-name') || 'BibleBee.Shop';
      if (!dest) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      var stamped =
        message +
        '\n\n--\nFrom: ' +
        name +
        ' <' +
        email +
        '>\nSent via ' +
        shopName +
        ' contact form\n' +
        new Date().toISOString();

      sending = true;
      if (submitBtn) submitBtn.disabled = true;
      setText(formStatus, 'Sending…');

      var controller = new AbortController();
      var timer = setTimeout(function () {
        controller.abort();
      }, 9000);

      fetch('https://formsubmit.co/ajax/' + encodeURIComponent(dest), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        signal: controller.signal,
        body: JSON.stringify({
          name: name,
          email: email,
          message: stamped,
          _subject: shopName + ' contact form',
          _template: 'table',
          _captcha: 'false'
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          var ok = data.success === true || data.success === 'true';
          if (!ok) {
            throw new Error(data.message || 'Send failed');
          }
          try {
            sessionStorage.setItem('biblebee-contact-sent', String(Date.now()));
          } catch (err) {
            /* ignore */
          }
          captcha.hidden = true;
          form.hidden = true;
          var done = document.createElement('p');
          done.className = 'contact-me__success';
          done.setAttribute('tabindex', '-1');
          done.textContent = 'Thanks — your message was sent. We will reply soon.';
          form.parentNode.insertBefore(done, form);
          done.focus();
        })
        .catch(function () {
          HTMLFormElement.prototype.submit.call(form);
        })
        .finally(function () {
          clearTimeout(timer);
          sending = false;
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-contact-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
